/**
 * Alert <uo-alert>
 *
 * Attributes:
 * heading      The heading of the alert
 * type         Type of the alert. "warning", "error", "success", "info"
 */

// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { customElement, property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { isEmpty } from '@automator/utilities';

// Import style for web component
import styles from './web-component-style.scss';

// eslint-disable-next-line require-jsdoc
@customElement( 'uo-alert' )
export class AutomatorAlert extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	@property( { type: Boolean, attribute: 'no-radius' } ) noRadius = false;

	@property( { type: Boolean, attribute: 'custom-icon' } ) customIcon = false;

	@property( { type: String } ) size;

	@property( { type: String } ) heading;

	@property( { type: String } ) type; // warning, error, success, info, white

	// eslint-disable-next-line require-jsdoc
	constructor() {
		super();
	}

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div
				class="alert"
				type=${ ifDefined( this.type ) }
				size=${ ifDefined( this.size ) }
				?no-radius=${ this.noRadius }
				?custom-icon=${ this.customIcon }
			>
				<div class="alert-icon">
					<slot name="icon"></slot>
				</div>

				<div class="alert-body">
					${ this.$heading }

					<div class="alert-content">
						<slot></slot>
					</div>
				</div>
			</div>
		`;
	}

	/**
	 * Returns the heading of the alert
	 *
	 * @return {TemplateResult} The TemplateResult of the alert heading
	 */
	get $heading() {
		// Check if there is a heading defined
		if ( isEmpty( this.heading ) ) {
			return;
		}

		// Parse curly quotes
		const heading = this.heading
			.replaceAll( '{{', '<strong>' )
			.replaceAll( '}}', '</strong>' );

		return html`
			<div class="alert-heading">
				<div class="alert-heading-text">
					${ unsafeHTML( heading ) }
				</div>
				
				<div class="alert-heading-icon">
					<slot name="top-right-icon"></slot>
				</div>
			</div>
		`;
	}
}
